import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_CHANGE_USERNAME_PASSWORD: MijnRoute = {
    path: 'gebruikersnaam-wachtwoord-wijzigen/:id',
    navigationEvent: 'toGebruikersnaamWachtwoordWijzigen',
    regex: /^\/zelf-regelen\/gebruikersnaam-wachtwoord-wijzigen\/[^/]+$/,
    webcomponent: 'mijn-tokens-digicode-webcomponent'
};
